/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Redeem_TitleInputs */

const en_common_sign_redeem_title = /** @type {(inputs: Common_Sign_Redeem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your invite code`)
};

const zh_common_sign_redeem_title = /** @type {(inputs: Common_Sign_Redeem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入邀请码`)
};

/**
* | output |
* | --- |
* | "Enter your invite code" |
*
* @param {Common_Sign_Redeem_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_redeem_title = /** @type {((inputs?: Common_Sign_Redeem_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Redeem_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_redeem_title(inputs)
	return zh_common_sign_redeem_title(inputs)
});
export { common_sign_redeem_title as "common.sign.redeem_title" }